import React from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import CardSkeleton from "./CardSkeleton";

const ProductDetailSkeleton = () => {
  return (
    <div className="container container-lg">
      <div className="d-flex justify-content-center justify-content-lg-around flex-wrap">
        <p className="mb-20 px-30">
          <Skeleton width={300} height={400} />
        </p>
        <div className="flex-center flex-column">
          <Skeleton width={300} height={20} />
          <Skeleton width={300} height={20} />
          <Skeleton width={300} height={20} />
          <Skeleton width={300} height={20} />

          <div className="flex-center flex-column my-40">
            <Skeleton width={300} height={20} />
            <Skeleton width={300} height={20} />
            <Skeleton width={300} height={20} />
            <Skeleton width={300} height={20} />
          </div>
        </div>
        <p className="mb-20 px-30">
          <Skeleton width={300} height={500} />
        </p>
      </div>
      <div className="row gy-4">
        <div className="col-xl-3">
          <div className="product-details__sidebar px-32 rounded-16">
            <Skeleton height={30} />
            <Skeleton height={50} />
            <Skeleton height={50} />
          </div>
        </div>
        <CardSkeleton />
      </div>
    </div>
  );
};

export default ProductDetailSkeleton;
